import map from 'lodash/map'
import React, { useEffect, useState, useRef } from 'react'
import {
    DatePicker,
    Form,
    Input,
    TimePicker,
    Select,
    Badge,
    Switch,
    Progress,
    Button,
} from 'antd'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import 'react-quill/dist/quill.core.css'
import QuillEditor from './Editor/editor.style'
import Editor from './Editor/editor'

const ButtonGroup = Button.Group

const FormItem = Form.Item
const { Option } = Select
const { TextArea } = Input
const CreateAntField = Component => ({
    field,
    form,
    hasFeedback,
    label,
    tasklabel,
    selectOptions,
    submitCount,
    type,
    formitem,
    className,
    ...props
}) => {
    const touched = form.touched[field.name]
    const submitted = submitCount > 0
    const hasError = form.errors[field.name]
    const submittedError = hasError && submitted
    const touchedError = hasError && touched
    const onInputChange = ({ target: { value } }) =>
        form.setFieldValue(field.name, value)
    const onChange = value => form.setFieldValue(field.name, value)
    const onBlur = () => form.setFieldTouched(field.name, true)
    return (
        <div className="field-container">
            <FormItem
                label={label}
                colon={false}
                className={className}
                hasFeedback={
                    (hasFeedback && submitted) || (hasFeedback && touched)
                        ? true
                        : false
                }
                help={submittedError || touchedError ? hasError : false}
                validateStatus={
                    submittedError || touchedError ? 'error' : 'success'
                }
                {...formitem}
            >
                {tasklabel && tasklabel}
                <Component
                    {...field}
                    {...props}
                    onBlur={onBlur}
                    onChange={type ? onInputChange : onChange}
                >
                    {selectOptions &&
                        selectOptions.map(data => (
                            <Option key={data.oid}>
                                <Badge status={data.oid} text={data.name} />
                            </Option>
                        ))}
                </Component>
            </FormItem>
        </div>
    )
}
const CreateAntProgress = () => ({
    field,
    form,
    hasFeedback,
    label,
    tasklabel,
    selectOptions,
    submitCount,
    type,
    formitem,
    className,
    ...props
}) => {
    const [percent, setpercent] = useState(props.defaultValue)
    const increase = () => {
        let temp = percent + 10
        if (temp > 100) {
            temp = 100
        }
        setpercent(temp)
        form.setFieldValue(field.name, temp)
    }

    const decline = () => {
        let temp = percent - 10
        if (temp < 0) {
            temp = 0
        }
        setpercent(temp)
        form.setFieldValue(field.name, temp)
    }

    const touched = form.touched[field.name]
    const submitted = submitCount > 0
    const hasError = form.errors[field.name]
    const submittedError = hasError && submitted
    const touchedError = hasError && touched
    const onInputChange = ({ target: { value } }) =>
        form.setFieldValue(field.name, value)
    const onChange = value => form.setFieldValue(field.name, value)
    const onBlur = () => form.setFieldTouched(field.name, true)
    return (
        <div className="field-container">
            <FormItem
                label={label}
                colon={false}
                className={className}
                hasFeedback={
                    (hasFeedback && submitted) || (hasFeedback && touched)
                        ? true
                        : false
                }
                help={submittedError || touchedError ? hasError : false}
                validateStatus={
                    submittedError || touchedError ? 'error' : 'success'
                }
                {...formitem}
            >
                {tasklabel && tasklabel}
                <div>
                    <Progress type="circle" percent={percent} />
                    <ButtonGroup style={{ marginLeft: 10 }}>
                        <Button onClick={decline} icon="minus" />
                        <Button onClick={increase} icon="plus" />
                    </ButtonGroup>
                </div>
            </FormItem>
        </div>
    )
}
function uploadCallback(file) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        xhr.open('POST', 'https://api.imgur.com/3/image')
        xhr.setRequestHeader('Authorization', 'Client-ID 8d26ccd12712fca')
        const data = new FormData()
        data.append('image', file)
        xhr.send(data)
        xhr.addEventListener('load', () => {
            const response = JSON.parse(xhr.responseText)
            console.log('load image', response)
            resolve(response)
        })
        xhr.addEventListener('error', () => {
            const error = JSON.parse(xhr.responseText)
            reject(error)
        })
    })
}
const createEditorForm = () => ({
    field,
    form,
    hasFeedback,
    label,
    tasklabel,
    selectOptions,
    submitCount,
    type,
    formitem,
    className,
    ...props
}) => {
    const [editorState, seteditorState] = useState(null)
    const [isEmpty, setisEmpty] = useState(false)

    const touched = form.touched[field.name]
    const submitted = submitCount > 0
    const hasError = form.errors[field.name]
    const submittedError = hasError && submitted
    const touchedError = hasError && touched
    const onInputChange = ({ target: { value } }) =>
        form.setFieldValue(field.name, value)
    const onChange = value => {
        // form.setFieldValue(field.name, value)

        if (
            value
                .replace('<p>', '')
                .replace('</p>', '')
                .trim() === ''
        ) {
            form.setFieldValue(field.name, '')
        } else {
            form.setFieldValue(field.name, value)
        }
    }
    const onBlur = () => form.setFieldTouched(field.name, true)
    const onEditorStateChange = editorState => {
        seteditorState(editorState)
    }
    const editorOption = {
        style: { width: '10 0%', height: '100%' },
        editorState: editorState,
        toolbarClassName: 'home-toolbar',
        wrapperClassName: 'home-wrapper',
        editorClassName: 'home-editor',
        onEditorStateChange: onEditorStateChange,
        uploadCallback: uploadCallback,
        toolbar: { image: { uploadCallback: uploadCallback } },
    }
    return (
        // <FormItem {...formitem}>
        <div className="field-container">
            <FormItem
                label={label}
                colon={false}
                className={className}
                hasFeedback={
                    (hasFeedback && submitted) || (hasFeedback && touched)
                        ? true
                        : false
                }
                help={submittedError || touchedError ? hasError : false}
                validateStatus={
                    submittedError || touchedError ? 'error' : 'success'
                }
                {...formitem}
            >
                <Editor
                    {...field}
                    {...props}
                    {...editorOption}
                    onChange={onChange}
                ></Editor>
            </FormItem>
        </div>
    )
}

export const AntSelect = CreateAntField(Select)
export const AntDatePicker = CreateAntField(DatePicker)
export const AntInput = CreateAntField(Input)
export const AntTimePicker = CreateAntField(TimePicker)
export const AntTextArea = CreateAntField(TextArea)
export const AntSwitch = CreateAntField(Switch)
export const AntProgress = CreateAntProgress()
export const AntEditor = createEditorForm()
